import React, { useEffect, useRef, useState } from 'react';

import AutocompleteSearchWithApi from '@/widgets/AutocompleteSearchWithApi';

import { QuickKeywords } from '../QuickKeywords';
import { VehicleModelProps } from './models';

import { Vehicle } from '@/client/services/core/vehicle/models';

export const VehicleModelSelect = ({
    onSearchVehicleBrands,
    onSubmitVehicleModel,
    vehicleList,
    title,
    value,
    autoFocus = false,
    isVehicleListLoading = false,
    quickKeywords = [],
    quickKeywordsHint
}: VehicleModelProps) => {
    const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (autoFocus && !value) inputRef.current?.focus();
    }, []);

    useEffect(() => {
        if (value) {
            setSelectedVehicle(value);
        }
    }, [value]);

    const onSelectChange = (vehicle: Vehicle) => {
        setSelectedVehicle(vehicle);
        onSubmitVehicleModel(vehicle);
    };

    const handleQuickKeyword = (keyword: string) => {
        const input = inputRef.current;
        if (!input) return;

        input.focus();
        input.select();
        if (document.execCommand('insertText', false, keyword)) return;

        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set?.call(input, keyword);
        input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: keyword }));
    };

    return (
        <>
            <AutocompleteSearchWithApi<Vehicle | null>
                slotProps={{ popper: { container: () => inputRef.current?.closest<HTMLElement>('[data-funnel-content]') ?? null } }}
                api={onSearchVehicleBrands}
                getOptionLabel={(item) => item.name}
                label={title}
                className='mt-4'
                loadingText='درحال جست‌وجو ...'
                loading={isVehicleListLoading}
                size='medium'
                defaultOption={
                    selectedVehicle ? [selectedVehicle, ...(vehicleList ?? []).filter((item) => item.id !== selectedVehicle.id)] : vehicleList
                }
                isOptionEqualToValue={(option: Vehicle, selected: Vehicle) => option.id === selected.id}
                value={selectedVehicle}
                defaultValue={selectedVehicle}
                onChange={onSelectChange}
                setInputRef={(input) => {
                    inputRef.current = input;
                }}
            />
            {!selectedVehicle && <QuickKeywords keywords={quickKeywords} onSelect={handleQuickKeyword} hint={quickKeywordsHint} />}
        </>
    );
};
